const height = 66;

export default {
    height,
};
